import { Button, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { CompaniesCsvImportModal } from '../CompaniesCsvImportModal';
import { UploadIcon } from '@/imports/ui/chakra/customIcon/UploadIcon';

export const BulkImportButton: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button variant="outline" colorScheme="primary" borderColor="primary.500" onClick={onOpen}>
        <UploadIcon mr="2" height="24px" width="28px" mt="-5px" />
        Bulk Import
      </Button>
      <CompaniesCsvImportModal open={isOpen} onClose={onClose} />
    </>
  );
};
